function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h140v140H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.981 86.997v-22.4h-5.676v22.608a1.028 1.028 0 01-.066.328l5.742-.536zm7.864-22.4H76.17v22.192l5.676-.525zm7.865 0h-5.677v21.46l5.676-.537zm2.187 0v20.726l.864-.087 2.953-20.64zm-25.78 22.608V64.597h-5.676v21.492l.875 2.1 4.943-.47a1.16 1.16 0 01-.142-.514zm-7.864-22.608h-6.77l6.77 16.242z",
  fill: "#ABC0D8",
  fillRule: "nonzero",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.342 102.19H46.9a1.772 1.772 0 01-1.247-3.009l11.528-11.517-14.218-36.76-8.75-1.587a1.762 1.762 0 11.634-3.467l9.69 1.76a1.75 1.75 0 011.324 1.095L60.878 87.5a1.75 1.75 0 01-.405 1.87l-9.318 9.33h44.187a1.76 1.76 0 010 3.522v-.033z",
  stroke: "#F58220",
  strokeWidth: 2,
  fill: "#FDB913",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F58220",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M84.547 60.79h16.078l-3.522 23.79-36.105 3.522m-7.054-27.311h18.287"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F58220",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 54.83,
  cy: 109.233,
  r: 3.522
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F58220",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 90.059,
  cy: 109.233,
  r: 3.522
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F58220",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M76.847 60.791h2.647"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FDB913",
  strokeWidth: 2,
  cx: 107.734,
  cy: 41.016,
  r: 3.828
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F1823B",
  strokeWidth: 2,
  cx: 28.984,
  cy: 79.297,
  r: 2.734
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#ABC0D8",
  fillRule: "nonzero",
  opacity: 0.3,
  cx: 30.078,
  cy: 106.641,
  r: 2.734
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.611 111.009l2.437-2.437a.76.76 0 011.074 0l2.437 2.437a.76.76 0 010 1.075l-2.437 2.436a.76.76 0 01-1.074 0l-2.437-2.436a.76.76 0 010-1.075z",
  fill: "#ABC0D8",
  fillRule: "nonzero",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.608 34.635l1.604-1.604a.49.49 0 01.693 0l1.604 1.604a.49.49 0 010 .693l-1.604 1.604a.49.49 0 01-.693 0l-1.604-1.604a.49.49 0 010-.693zm-73.245-8.281l2.032-2.033a.63.63 0 01.891 0l2.033 2.033a.63.63 0 010 .89l-2.033 2.033a.63.63 0 01-.89 0l-2.033-2.032a.63.63 0 010-.891z",
  fill: "#FDB913",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#ABC0D8",
  fillRule: "nonzero",
  opacity: 0.3,
  cx: 72.034,
  cy: 40.239,
  r: 15.083
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F58220",
  strokeWidth: 2,
  fill: "#FDB913",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 74.222,
  cy: 36.958,
  r: 15.083
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M68.742 42.438l10.96-10.949m0 10.949l-10.96-10.949"
}));

function SvgCartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCartEmpty;